import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    name: 'login',
    component: Login,
    props: (route) => ({
      redirect_uri: route.query.redirect_uri
    })
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js